export default __webpack_public_path__ + "static/media/January2021.671f186a.png";